import {Table, Tabs, Typography} from 'antd'

import React, {useState, useEffect} from 'react'
import ClaimTable from './ClaimTable';
import ClaimTableDiscord from './ClaimTableDiscord';
import { Link } from 'react-router-dom';
import ClaimTableTwitter from './ClaimTableTwitter';
const { Title, Paragraph, Text } = Typography;

function Verify({includeBack}) {
  const [key, setKey] = useState('dogecoin')
    useEffect(() => {
      if (window.location.hash === "#discord"){
        setKey('discord')
      }
      
    }, [])
    
    const DataBurns = [
      {
        date: "2022-04-23",
        amount: 2000000000000,
        hash: "24948BA3CA539BF289F8FBC526952549550582F97A3A26104D2BC47345FD8D9C",
      },
      {
        date: "2023-05-27",
        amount: 700000000000,
        hash: "A12D09FFF639E5589915FE21D46D051416E797CE64F2711079C70ED5DFA020C1",
      },
      {
        date: "2024-04-20",
        amount: 562241382651,
        hash: "F24D324DA0B53F1D23A1AB48E062957D47D786277C86FECEF7E7A178A7DD6CFC",
      },
      {
        date: "2025-04-10",
        amount: 100000,
        hash: "F85AC4BB320253F5743E949EEAAE356C772E933749F63ECFDE8B96FB3166B1EA",
      },
      {
        date: "2025-04-10",
        amount: 140572186558.20963,
        hash: "B807F47B6DBCE1C8988B592032B589FAC6D5260BF2EDC28369CA967CE3720239",
      }
    ]

  return (
    <div style={{margin: 16}}>
      {
        includeBack && <Link to={'/'} style={{fontSize: "1.5em"}}>DogeNano</Link>
      }
          <p style={{  }}>
                          The total supply is <b>10,000,000 XDG</b>:<br />
                          <ul>
                              <li>
                              <b>8,990,451 XDG</b> was distributed to Dogecoin holders via <Link scr to={'/distribution'}>airdrop to Dogecoin holders</Link>.<br />
                              </li>
                              <li>
                                  <b>1,009,549 XDG</b> was distributed through free <a href="https://discord.gg/B7eDT2NtcK" target='_blank'>Discord</a> and <a href="https://twitter.com/dogenanoIO" target='_blank'>X (Twitter)</a> airdrops<br />
                              </li>
                          </ul>
                          </p>
    <p >
    Distribution lasted 3 years and ended on 4/20/2025. No more XDG can be issued. <br/>
    The entire distribution can be checked below and can be <a
    onClick={async () => {
      // download from /distribution-data/dogecoin.claims.zip
      const blob = await import('./distribution-data/xdg-distribution.zip');
      const response = await fetch(blob.default);
      const blobData = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blobData]));
      const a = document.createElement('a');

      a.style.display = 'none';
      a.href = url;
      a.download = 'xdg-distribution.zip';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();

    }}
    >downloaded.</a>
     <br/>
    {/* All distribution claims are public and have been recorded to make distribution as transaparent and verifiable as possible. <br/> */}
    {/* Distribution data (JSON) can be downloaded with <a href="https://api.dogenano.io/get-claims">api.dogenano.io/get-claims</a> and <a href="https://api.dogenano.io/get-discord-claims">api.dogenano.io/get-discord-claims</a> */}

    {/* <Title level={2} style={{marginTop: 16, marginBottom: 8}}>How to verify</Title>
      <Title level={3} style={{marginTop: 16, marginBottom: 8}}>Distribution to dogecoin holders (>80% supply)</Title>
      <ol>
        <li>
        Verify message and signature below (eg: with MultiDoge Wallet or <a href='https://github.com/Dogenano-xdg/dogecoin-signature-tool'>Dogecoin signature tool</a>) 
        </li>
        <li>
        Verify Dogecoin Address Balance at block 4,191,928 (eg: With <a href='https://dogechain.info/' target={"_blank"}>dogechain.info</a>)
        </li>
        <li>
            <ul>
              <li>
                  For claims before 4/20/2023 4:20:00 PM UTC, XDG sent must be equal to 10x Dogecoin Balance at block 4,191,928
              </li>
              <li>
              For claims after 4/20/2024 4:20:00 PM UTC, XDG sent must be equal to 5x Dogecoin Balance at block 4,191,928, and should be capped at 1,000,000 XDG per claim.
              </li>
            </ul>
        </li>
      </ol> 
      <Title level={3} style={{marginTop: 16, marginBottom: 8}}> Discord Airdrops (&lt;10% supply)</Title>
      Airdrop #1: <br/>
        420 XDG has been sent to the first 1000 claimers on <a href="https://discord.gg/B7eDT2NtcK">Discord</a>. <br/>
        <ol style={{marginBottom: 4}}>
          <li>Discord Account must be created before 4/20/22</li>
          <li>Discord Account must be verified by third party <a href='https://dcounter.space/' target={"_blank"}>dcounter</a> </li>
          <li>Discord User Id, Discord claim message id and discord verification message id are shown in the table below and can be viewed on Discord. </li>
        </ol>
      Airdrop #2 (ongoing): <br/>
        100 XDG has been sent to the first 4200 claimers on <a href="https://discord.gg/B7eDT2NtcK">Discord</a>. <br/>
        <ol style={{marginBottom: 4}}>
          <li>Discord Account must be created before 01/09/22</li>
          <li>Discord Account must be verified by third party <a href='https://dcounter.space/' target={"_blank"}>dcounter</a> </li>
          <li>Discord User Id, Discord claim message id and discord verification message id are shown in the table below and can be viewed on Discord. </li>
        </ol>
    <br/> */}
    </p>
    <div style={{fontSize: "1.35em"}}>

    <Tabs defaultActiveKey="burn" activeKey={key} onChange={(key) => setKey(key)}>
    
    <Tabs.TabPane tab="Dogecoin holders Airdrop" key="dogecoin">
      <ClaimTable />
    </Tabs.TabPane>
    <Tabs.TabPane tab="X (Twitter) Airdrop" key="x">
      <ClaimTableTwitter />
    </Tabs.TabPane>
    <Tabs.TabPane tab="Discord Airdrop" key="discord">
      <ClaimTableDiscord />
    </Tabs.TabPane>
    <Tabs.TabPane tab="Official Burn" key="burn">
    xdg_1111111111111111111111111111111111111111111111111111hifc8npp is a burn address hard coded in dogenano node, any XDG sent to this address is removed from circulation. <br/>
    <b>Total burned:</b> {DataBurns.reduce((a, b) => a + b.amount, 0).toLocaleString('en-US')} XDG<br/>
      <Table
      size='small'
      pagination={{defaultPageSize: 5}}
      columns={[
        {
          title: 'Date',
          dataIndex: 'date',
          key: 'date',
          render: (d) => new Date(d).toLocaleDateString() 
        },
        {
          title: 'XDG Burned',
          dataIndex: 'amount',
          key: 'amount',
        },
        {
          title: 'DogeNano Hash',
          dataIndex: 'hash',
          key: 'hash',
          render: (r) => <a target='_blank' href={'https://explorer.dogenano.io/block/'+r}>View</a>
        },
      ]}
      dataSource={DataBurns}
      />
      
    </Tabs.TabPane>
    </Tabs>
    </div>
    </div>
  )
}

export default Verify